import React, { useState, useEffect } from "react";
import styles from "./AuthForm.module.scss";

const AuthForm = ({ mode, onSubmit, resetForm }) => {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (resetForm) {
      setEmail("");
      setUsername("");
      setPassword("");
    }
  }, [resetForm]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (mode === "Signup") {
      onSubmit({ email, username, password });
    } else {
      onSubmit({ username, password });
    }
  };

  return (
    <form onSubmit={handleSubmit} className={styles["auth-form"]}>
      <h2>{mode}</h2>
      {mode === "Signup" && (
        <div>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
      )}
      <div>
        <label>Username</label>
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>
      <button type="submit">{mode}</button>
    </form>
  );
};

export default AuthForm;
